import { fromJS } from 'immutable';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SAVE_FAILED,
  REMOVE,
  REMOVE_SUCCESS,
  REMOVE_FAILED,
} from './constants';
import { CauseFormPageActions } from './actions';

export interface CauseFormState {
  loading: boolean;
}

export const initialState = fromJS({
  loading: true,
});

function causeFormPageReducer(state = initialState, action: CauseFormPageActions): CauseFormState {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false });

    case SAVE_FAILED:
      return state.merge({ errorCode: action.errorCode });

    case REMOVE:
      return state.set('loading', true);

    case REMOVE_SUCCESS:
      return state.set('loading', false);

    case REMOVE_FAILED:
      return state.merge({ errorCode: action.errorCode });

    default:
      return state;
  }
}

export default causeFormPageReducer;
